<template>
  <div>
    <Nav v-bind:organization="organization" />
    <div class="app">
      <Sidebar />
      <div id="organization_main_view">
        <SiteStrategyTests v-bind:strategy="strategy" v-bind:tests="tests" />
      </div>
    </div>
  </div>
</template>

<script>
import "../css/main.css";
import "../css/components.css";

import utils from "../js/utils.js";
import EventBus from "@/js/event-bus.js";

import Table from "./generics/Table";
import Sidebar from "./generics/Sidebar";
import Nav from "./generics/Nav";
import SiteStrategyTests from "./special/SiteStrategyTests";

import store from '@/js/store';

export default {
  name: 'OrganizationMainView',
  data () {
    const data = {
      organization: {},
      site: {},
      strategy: {},
      tests: [],
      overlay: ``,
    };

    (async () => {
      const { public_key, strategy_public_key } = this.$route.params;
      const { organization, sites, testing } = await utils.generalInformation({ site_public_key: public_key });

      data.strategy = testing.strategies.find(o => o.public_key === strategy_public_key);
      data.tests = data.strategy.tests;
    })();

    return data;
  },

  methods: {
    async updateStrategies () {
      const strategies = (await utils.generalInformation({ update: ["strategies"] })).testing.strategies;
      this.$data.strategies = strategies;
    },
  },

  mounted () {
    EventBus.$on("createTest", test => {
      this.$data.tests.push(test);
      console.log(test);
    })
  },

  components: {
    SiteStrategyTests,
    Sidebar,
    Nav,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app {
  text-align: center;
  margin-top: 20px;
}

#organization_main_view {
  display: inline-block;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganizationSiteTestingStrategy.vue